import groupBy from "lodash/groupBy";
import type {DocumentWarning, FormattedWarnings} from "types/documentData";

// the only fields the panel flags; a warning about any other field is listed above the fields
const KNOWN_PATHS = ["creditBankAccount", "invoiceNumber", "supplierName"];

/**
 * Groups the warnings by the field they are flagged on. A warning about a field the panel doesn't
 * flag, or that the document doesn't have, goes under "" and is shown above the fields.
 * Unlike taskdetails-remake/panels/formatWarnings it leaves the warnings it is given unchanged.
 */
export const formatWarnings = (warnings: DocumentWarning[] | null | undefined, documentPaths?: string[]): FormattedWarnings => {
    if (!warnings?.length) {
        return {};
    }

    const knownPaths = documentPaths ? KNOWN_PATHS.filter(path => documentPaths.includes(path)) : KNOWN_PATHS;
    const mappedWarnings = warnings.map(warning => ({
        ...warning,
        path: warning.path && knownPaths.includes(warning.path) ? warning.path : "",
    }));

    return groupBy(mappedWarnings, "path");
};
